import styled from 'styled-components';

export const Main = styled.div`
  flex: 1 0 auto;
  width: 100vw;
  height: 100%;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
`;
export const Block = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const ListsWrapper = styled.div`
  height: ${props => `calc(100% - ${(props.searchBoxHeight || 0) + 51}px)`};
  @media (max-height: 530px) {
    height: ${props => `calc(100% - ${(props.searchBoxHeight || 0) + 31}px)`};
  }
`;
